import angular from 'angular';

import CalendarModule from './calendar';
import UserModule from './user';
import TeamModule from './team';
import PaymentModule from './payment';
import DashboardModule from './dashboard';
import AnalyticsModule from './analytics';

import SessionService from './session.service';
import NotificationService from './notification.service';
import ModalService from './modal.service';
import ThemeService from './theme.service';
import AppStartCacheService from './app-start-cache.service';
import analyticsService from 'common/analytics';

export default angular
    .module('application.service', [
        CalendarModule.name,
        UserModule.name,
        TeamModule.name,
        PaymentModule.name,
        DashboardModule.name,
        AnalyticsModule.name
    ])
    .service('sessionService', SessionService)
    .service('notificationService', NotificationService)
    .service('modalService', ModalService)
    .service('themeService', ThemeService)
    .service('appStartCacheService', AppStartCacheService)
    .factory('analyticsService', () => analyticsService);



// WEBPACK FOOTER //
// ./src/application/service/index.js